const StatusList = [
  { label: 'Closed', value: 'closed' },
  { label: 'Closeout In Progress', value: 'closeoutInProgress' },
  { label: 'Open', value: 'open' },
  { label: 'Withdrawn', value: 'withdrawn' }
];

export default { StatusList };
